// extracted by mini-css-extract-plugin
export default {"table":"style_table__qdVat","line":"style_line__nMGR8"};